import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
  path: '',
  component: () => import_latest_version_module(),
  children: [
    {
      path: '/admin/special-offer-product-audit-list',
      name: 'admin-special-offer-product-audit-list',
      component: () => import(/* webpackChunkName: "page-admin-tourism-product-management-special-offer-product-audit-list" */ `./index.vue`),
      meta: {
          data_for_admin_layout: {
                    data_for_history_tag: {
                              entity: {
                                        name: "旅游特价产品审核列表"
                              }
                    },
                    data_for_breadcrumb: {
                              entity_list: [
                                        {
                                                  name: "旅游产品管理"
                                        },
                                        {
                                                  name: "旅游特价产品审核列表"
                                        }
                              ]
                    }
          }
},
    },
  ],
};
